var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',{attrs:{"title":_vm.$it('inspection.detail.appraisals.title', 'Appraisals'),"guttered":false}},[_c('appraisal-list',{attrs:{"appraisals":_vm.appraisals},on:{"updated":function($event){return _vm.$emit('updated')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }